// Maestro-detalle de las pantallas con ciclo de vida: lista y editor siempre en 3/5.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { MasterDetail } from '@/shared/patterns/MasterDetail';

export const LIFECYCLE_SPLIT_CLASS = 'grid-cols-[minmax(0,3fr)_minmax(0,5fr)]';

export function LifecycleMasterDetail({
    list,
    detail,
    className,
}: {
    list: ReactNode;
    detail: ReactNode;
    className?: string;
}) {
    return (
        <MasterDetail
            className={cn(LIFECYCLE_SPLIT_CLASS, className)}
            list={list}
            detail={detail}
        />
    );
}
